// npm packages
import React, { useState, useEffect, useContext, Fragment } from "react";
import parse from "html-react-parser";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

// custom pages
import QualityAnalyzerAPI from "apis/panel/qualityAnalyzer/qualityAnalyzer";
import Context from "context/context";

// material ui
import dayjs from "dayjs";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Button, Autocomplete } from "@mui/material";

const QualityDetails = ({ paramsIds, onClose, filters, offset, accessionfilter, filterapplied, accessioncount }) => {
  const location = useLocation();
  const { state, dispatch } = useContext(Context);
  const paramsId = paramsIds;
  const [serialNo, setSerialNo] = useState(offset)
  const [count, setCount] = useState(accessioncount);
  const {
    getAccessionDetailsAPI,
    getErrorCategoriesAPI,
    updateAccessionDetailsAPI,
    getActionableItemsAPI,
    getErrorSummariesAPI
  } = QualityAnalyzerAPI();

  const [data, setData] = useState([]);
  const [parentData, setParentData] = useState({});
  const [errorCategories, setErrorCategories] = useState([]);
  const [errorSummaries, setErrorSummaries] = useState([]);
  const [actionableItems, setActionableItems] = useState([]);
  const [editableData, setEditableData] = useState([]);
  const [handledBy, setHandledBy] = useState("");
  const [auditedBySME, setAuditedBySME] = useState("");
  const [SMEAuditResult, setSMEAuditResult] = useState("");
    const [SMEComments, setSMEComments] = useState("");
  const [editAccess, setEditAccess] = useState(false);


  const handleGetData = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });

      const values = filterapplied
        ? {
          offset: serialNo - 1,
          practiceName: accessionfilter.practiceName?.label || undefined,
          radiologistName: accessionfilter.radName?.label || undefined,
          modalityName: accessionfilter.modalityName?.label || undefined,
          vraArray: (accessionfilter.vraName || []).map(
            (item) => item.label
          ),
          accessionArray: (accessionfilter.accessionNumbers || []).map(
            (item) => item.label
          ),
          status: accessionfilter.status,
          ...(accessionfilter.startDate && {
            startDate: dayjs(accessionfilter.startDate).format("YYYY-MM-DD"),
          }),
          ...(accessionfilter.endDate && {
            endDate: dayjs(accessionfilter.endDate).format("YYYY-MM-DD"),
          }),
        }
        : {
          offset: serialNo - 1,
          practiceName: filters.practiceName?.label || undefined,
          radiologistName: filters.radName?.label || undefined,
          modalityName: filters.modalityName?.label || undefined,
          startDate: filters.startDate
            ? dayjs(filters.startDate).format("YYYY-MM-DD")
            : dayjs().subtract(1, "day").format("YYYY-MM-DD"),
          endDate: filters.endDate
            ? dayjs(filters.endDate).format("YYYY-MM-DD")
            : dayjs().format("YYYY-MM-DD"),
        };


      const res = await getAccessionDetailsAPI(values);
      if (res?.data?.data && res?.data?.data?.length > 0) {
        const resData = res?.data?.data;
        setData(resData);
        setEditableData(
          resData?.filter((d) => d.addedWords > 0 || d.deletedWords > 0)
        );
      }
      if (
        res?.data?.parentData &&
        Object.keys(res?.data?.parentData)?.length > 0
      ) {
        setParentData(res?.data?.parentData);
        setHandledBy(res?.data?.parentData?.handledBy || "");
        setAuditedBySME(res?.data?.parentData?.isAuditedBySME || "No");
        setSMEAuditResult(res?.data?.parentData?.SMEAuditResult || "Pass");
        setSMEComments(res?.data?.parentData?.SMEComments || "");
      }
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (err) {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleGetErrorCategories = async () => {
    try {
      const res = await getErrorCategoriesAPI();
      if (res?.data?.data && res?.data?.data?.length > 0) {
        const resData = res?.data?.data;
        setErrorCategories(resData);
      }
    } catch (err) { }
  };

  const handleGetErrorSummaries = async () => {
    try {
      const res = await getErrorSummariesAPI();
      if (res?.data?.data && res?.data?.data?.length > 0) {
        const resData = res?.data?.data;
        setErrorSummaries(resData);
      }
    } catch (err) { }
  };


  const handleGetActionableCategories = async () => {
    try {
      const res = await getActionableItemsAPI();
      if (res?.data?.data && res?.data?.data?.length > 0) {
        const resData = res?.data?.data;
        setActionableItems(resData);
      }
    } catch (err) { }
  };



  useEffect(() => {
    if (parentData && Object.keys(parentData)?.length > 0) {
      if ((state?.role?.roleCode === "R008" || state?.role?.roleCode === "R012" || state?.role?.roleCode === "R013") && parentData?.status === "New") {
        setEditAccess(true)
      } else if (state?.role?.roleCode === "R001" || state?.role?.roleCode === "R004" || state?.role?.roleCode === "R009" || state?.role?.roleCode === "R010" || state?.role?.roleCode === "R011") {
        setEditAccess(true)
      }
    }
  }, [state.role, parentData])

  useEffect(() => {
    if (paramsId) {
      handleGetData();
      handleGetErrorCategories();
      handleGetErrorSummaries();
      handleGetActionableCategories();
    }
  }, [paramsId]);

  const handleInputChange = (index, key, value) => {

    setEditableData([
      ...editableData.slice(0, index),
      {
        ...editableData[index],
        [key]: value,
      },
      ...editableData.slice(index + 1),
    ]);
  };


  const handleSubmit = async () => {
   
    dispatch({ type: "SET_LOADING", payload: true });
    let error = false;
    let values = {};

    if (editableData?.length > 0) {
      let input = [];
      editableData?.map((e) => {
        input = [
          ...input,
          {
            vraQualityReportId: e.vraQualityReportId,
            actualError: e.actualError,
            errorCategoryId: e.errorCategoryId,
            errorSummaryId: e.errorSummaryId,
            errorComments: e.errorComments,
            actionableItemIds: e.actionableItem,
            additionalRemarks: e.additionalRemarks,
          },
        ];
        if (
          (e.actualError === "Yes" &&
            (!e.errorSummaryId) ||
            (!e.errorCategoryId || !e.errorComments)) ||
          (!e.actualError &&
            !e.errorCategoryId &&
            !e.errorComments && !e.errorSummaryId &&
            (!e.actionableItem || e.actionableItem?.length === 0))
        ) {
          error = true;
        }
      });
      //   if (
      //     (e.actualError === "Yes" &&
      //       (!e.errorCategoryId || !e.errorComments)) ||
      //     (!e.actualError && !e.errorCategoryId && !e.errorComments && !e.actionableItem)
      //   )
      //     error = true;
      // });

      if (error) {
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.error("Please fill in all required fields.", {
          toastId: "quality-dashboard-submit-error",
        });
      }
      values = {
        input,
      };
    }

    if (handledBy) {
      values = {
        ...values,
        handledBy,
      };
    }

    values = {
      ...values,
      auditedBySME: auditedBySME,
      vraQualityDetailId: paramsId,
    }
    try {
      const res = await updateAccessionDetailsAPI(values);
      if (res?.status === "Ok") {
        toast.success("Your request has been processed successfully.", {
          toastId: "quality-dashboard-submit-success",
        });
      }
      console.log("before get data", serialNo)
      handleGetData();
      console.log("after get data", serialNo)
      dispatch({ type: "SET_LOADING", payload: false });
    } catch (err) {
      console.log({ err });
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleSubmitClose = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    let error = false;
    let values = {};

    if (editableData?.length > 0) {
      let input = [];
      editableData?.map((e) => {
        input = [
          ...input,
          {
            vraQualityReportId: e.vraQualityReportId,
            actualError: e.actualError,
            errorCategoryId: e.errorCategoryId,
            errorSummaryId: e.errorSummaryId,
            errorComments: e.errorComments,
            actionableItemIds: e.actionableItem

          },
        ];
        if (
          (e.actualError === "Yes" &&
            (!e.errorSummaryId) ||
            (!e.errorCategoryId || !e.errorComments)) ||
          (!e.actualError &&
            !e.errorCategoryId &&
            !e.errorComments &&
            (!e.actionableItem || e.actionableItem?.length === 0))
        ) {
          error = true;
        }
      });


      if (error) {
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.error("Please fill in all required fields.", {
          toastId: "quality-dashboard-submit-error",
        });
      }
      values = {
        input,
      };
    }

    if (handledBy) {
      values = {
        ...values,
        handledBy,
      };
    }
    values = {
      ...values,
      auditedBySME: auditedBySME,
      SMEAuditResult:SMEAuditResult,
      SMEComments:SMEComments,
      vraQualityDetailId: paramsId,
    }
    try {
      const res = await updateAccessionDetailsAPI(values);
      if (res?.status === "Ok") {
        toast.success("Your request has been processed successfully.", {
          toastId: "quality-dashboard-submit-success",
        });
      }
      handleGetData();
      onClose();

      dispatch({ type: "SET_LOADING", payload: false });
    } catch (err) {
      console.log({ err });
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  useEffect(() => {
    handleGetData();
  }, [serialNo])

  const handleSubmitNext = async () => {
    dispatch({ type: "SET_LOADING", payload: true });
    let error = false;
    let values = {};

    if (editableData?.length > 0) {
      let input = [];
      editableData?.map((e) => {
        input = [
          ...input,
          {
            vraQualityReportId: e.vraQualityReportId,
            actualError: e.actualError,
            errorCategoryId: e.errorCategoryId,
            errorSummaryId: e.errorSummaryId,
            errorComments: e.errorComments,
            actionableItemIds: e.actionableItem
          },
        ];
        if (
          (e.actualError === "Yes" &&
            (!e.errorSummaryId) ||
            (!e.errorCategoryId || !e.errorComments)) ||
          (!e.actualError &&
            !e.errorCategoryId &&
            !e.errorComments &&
            (!e.actionableItem || e.actionableItem?.length === 0))
        ) {
          error = true;
        }
      });


      if (error) {
        dispatch({ type: "SET_LOADING", payload: false });
        return toast.error("Please fill in all required fields.", {
          toastId: "quality-dashboard-submit-error",
        });
      }
      values = {
        input,
      };
    }

    if (handledBy) {
      values = {
        ...values,
        handledBy,
      };
    }
    values = {
      ...values,
      auditedBySME: auditedBySME,
      SMEAuditResult:SMEAuditResult,
      SMEComments:SMEComments,
      vraQualityDetailId: paramsId,
    }


    try {
      const res = await updateAccessionDetailsAPI(values);
      if (res?.status === "Ok") {
        toast.success("Your request has been processed successfully.", {
          toastId: "quality-dashboard-submit-success",
        });
      }


      if (!filterapplied) {

        setSerialNo(prev => prev + 1);
      }
      else if (filterapplied && accessionfilter.status == "Completed") {
        setSerialNo(prev => prev + 1);
      }
      else {
        setCount(prev => prev - 1);
        handleGetData();
      }




      dispatch({ type: "SET_LOADING", payload: false });
    } catch (err) {
      console.log({ err });
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  return (
    <div className="quality-view-main">
      {parentData && Object.keys(parentData)?.length > 0 && (
        <Fragment>
          <div className="quality-view-header">Accession Details:</div>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Practice Name:</b> {parentData?.practiceName}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Radiologist Name:</b> {parentData?.radName}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Modality:</b> {parentData?.modalityName}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Accession Number:</b> {parentData?.accessionNumber}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Date:</b> {parentData?.date}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> VRA Name:</b> {parentData?.vraName}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Accuracy Score:</b> {parentData?.accuracyScore}%
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Deviation Percentage:</b> {parentData?.overallPercentage}%
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Error Percentage:</b> {parentData?.errorPercentage}%
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Actual Deviation Percentage:</b> {parentData?.actualDeviationPercentage}%
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Result Status:</b> &nbsp;
              {parentData?.performanceStatus === "Pass" ? (
                <span className="quality-view-success">
                  {parentData?.performanceStatus}
                </span>
              ) : (
                <span className="quality-view-failed">
                  {parentData?.performanceStatus}
                </span>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Accession Handled By:</b>{" "}
              {parentData?.handledBy ? parentData?.handledBy : "-"}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Status:</b>{" "}
              {parentData?.status ? <span style={{ color: parentData.status === "New" ? "red" : "green" }}>{parentData?.status}</span> : "-"}
            </Grid>
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={3}
              className="quality-view-accession-details"
            >
              <b> Source System:</b> {parentData?.sourceSystem}
            </Grid>
          </Grid>
        </Fragment>
      )}

      {data?.length > 0 && (
        <Fragment>
          <div className="quality-view-header">Comparison:</div>
          <Table
            sx={{ minWidth: 650 }}
            aria-label="simple table"
            className="custom-table"
          >
            <TableHead className="custom-table-head">
              <TableRow>
                <TableCell>Section</TableCell>
                <TableCell>VRA Draft Report</TableCell>
                <TableCell>RAD Final Draft</TableCell>
                <TableCell>RAD Final Report</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="custom-table-body">
              {data?.length > 0 &&
                data?.map((d, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      <b>{d?.sectionName}</b>
                    </TableCell>
                    <TableCell>{d?.vraReport}</TableCell>
                    <TableCell>{d?.radReport}</TableCell>
                    <TableCell className="final-report-text">
                      {parse(d?.finalReport)}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Fragment>
      )}

      <Fragment>
        <div className="quality-view-header">Review Status:</div>
        <div>
          {editableData?.map((d, i) => (
            <div key={i}>
              <Grid container spacing={2} sx={{ pl: 2, pt: 3, pr: 2 }}>
                <Grid
                  item
                  xs={12}
                  sm={2}
                  md={2}
                  lg={2}
                  style={{ alignSelf: "center", textAlign: "center" }}
                >
                  {d.sectionName}
                </Grid>
                <Grid item xs={12} sm={2} md={2} lg={2}>
                  <Box className="label">
                    Is this an actual error?&nbsp;
                    <span style={{ color: "red" }}>*</span>
                  </Box>
                  <FormControl fullWidth>
                    <Select
                      labelId="actual-error"
                      id="actual-error"
                      name="actual-error"
                      defaultValue=""
                      displayEmpty
                      disabled={!editAccess}
                      value={d?.actualError}
                      onChange={(e) => {
                        {
                          setEditableData([
                            ...editableData.slice(0, i),
                            {
                              ...editableData[i],
                              errorCategoryId: [],
                              errorSummaryId: "",
                              errorComments: "",
                              actualError: e.target.value,
                              actionableItem: []

                            },
                            ...editableData.slice(i + 1),
                          ]);
                        }
                      }}
                      inputProps={{ "aria-label": "Without label" }}

                    >
                      <MenuItem value={"Yes"}>Yes</MenuItem>
                      <MenuItem value={"No"}>No</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {d?.actualError === "Yes" ? (
                  <Fragment>
                    <Grid item xs={12} sm={2} md={2} lg={2}>
                      <Box className="label">
                        Select Error Summary&nbsp;
                        <span style={{ color: "red" }}>*</span>
                      </Box>
                      <FormControl fullWidth>
                        <Autocomplete
                          id="error-summary-id"
                          name="error-summary-id"
                          options={errorSummaries || ""}
                          getOptionLabel={(option) => option.errorSummaryName || ""}
                          disabled={!editAccess}
                          value={
                            errorSummaries.find((ec) => ec.errorSummaryId === d?.errorSummaryId) || null
                          }
                          onChange={(event, newValue) => {
                            handleInputChange(i, "errorSummaryId", newValue?.errorSummaryId || null);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              fullWidth
                            />
                          )}
                          isOptionEqualToValue={(option, value) => option.errorSummaryId === value.errorSummaryId}
                        />
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={2} md={2} lg={2}>
                      <Box className="label">
                        Select Error Category&nbsp;
                        <span style={{ color: "red" }}>*</span>
                      </Box>
                      <FormControl fullWidth>
                        <Autocomplete
                          multiple
                          allowDuplicate
                          id="error-category-id"
                          name="error-category-id"
                          options={errorCategories || []}
                          getOptionLabel={(option) => option.errorName || ""}
                          disabled={!editAccess}
                          value={errorCategories.filter((ec) => d?.errorCategoryId?.includes(ec.errorId)) || []}// This holds the selected values (an array)
                          onChange={(event, newValue) => {
                            const selectedIds = newValue.map((item) => item.errorId);
                            handleInputChange(i, "errorCategoryId", selectedIds); // Update the selected values
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}

                              variant="outlined"
                              fullWidth
                            />
                          )}
                          isOptionEqualToValue={(option, value) => option.errorId === value.errorId}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={2} md={2} lg={2}>
                      <Box className="label">
                        Provide Comments&nbsp;
                        <span style={{ color: "red" }}>*</span>
                      </Box>
                      <FormControl fullWidth>
                        <TextField
                          // sx={{ border: "1px solid #B2D4F8" }}
                          id="error-comments"
                          name="error-comments"
                          variant="outlined"
                          fullWidth
                          disabled={!editAccess}
                          value={d?.errorComments}
                          onChange={(e) => {
                            handleInputChange(
                              i,
                              "errorComments",
                              e.target.value
                            );
                          }}
                        />
                      </FormControl>
                    </Grid>{" "}
                    <Grid item xs={12} sm={2} md={2} lg={2}>
                      <Box className="label">
                        Select Actionable Item&nbsp;
                        <span style={{ color: "red" }}>*</span>
                      </Box>
                      <FormControl fullWidth>
                        <Autocomplete
                          multiple
                          id="actionable-item-id"
                          name="actionable-item-id"
                          options={actionableItems || []}
                          getOptionLabel={(option) => option.actionableItems || ""}  // Display label
                          value={actionableItems.filter((item) => d?.actionableItem?.includes(item.actionableId)) || []}
                          disabled={!editAccess}
                          onChange={(event, newValue) => {
                            const selectedIds = newValue.map((item) => item.actionableId);
                            handleInputChange(i, "actionableItem", selectedIds);  // Update the selected values
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="outlined"
                              fullWidth
                            />
                          )}
                          isOptionEqualToValue={(option, value) => option.actionableId === value.actionableId}  // Ensure correct matching
                        />
                      </FormControl>
                    </Grid>


                  </Fragment>

                ) : (d?.actualError === "No" ? (
                  <Fragment>
                    <Grid item xs={12} sm={3} md={3} lg={3}>
                      <Box className="label">
                        Provide Comments&nbsp;
                        <span style={{ color: "red" }}>*</span>
                      </Box>
                      <FormControl fullWidth>
                        <TextField
                          // sx={{ border: "1px solid #B2D4F8" }}
                          id="error-comments"
                          name="error-comments"
                          variant="outlined"
                          fullWidth
                          disabled={!editAccess}
                          value={d?.errorComments}
                          onChange={(e) => {
                            handleInputChange(
                              i,
                              "errorComments",
                              e.target.value
                            );
                          }}
                        />
                      </FormControl>
                    </Grid>{" "}
                  </Fragment>
                ) : null
                )}
              </Grid>
            </div>
          ))}


          {/* <Grid container spacing={1} sx={{ pl: 2, pt: 3, pr: 2 }}>
            <Grid
              item
              xs={12}
              sm={2}
              md={2}
              lg={2}
              style={{ alignSelf: "center", textAlign: "center" }}
            >
              Accession Handled By
            </Grid>
            <Grid container spacing={2} xs={12} sm={8} md={8} lg={8}>
              <Grid item xs={12} sm={3} md={3} lg={3}>
                <Box className="label">Primary / Secondary VRA</Box>
                <FormControl fullWidth>
                  <Select
                    labelId="vra-label-1"
                    id="vra-select-1"
                    name="vra-select-1"
                    defaultValue=""
                    displayEmpty
                    disabled={!editAccess}
                    value={handledBy}
                    onChange={(e) => {
                      setHandledBy(e.target.value);
                    }}
                    inputProps={{ "aria-label": "Primary or Secondary VRA" }}
                  >
                    <MenuItem value={"Primary VRA"}>Primary VRA</MenuItem>
                    <MenuItem value={"Substitute VRA"}>Substitute VRA</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} sm={3} md={3} lg={3}>
                <Box className="label">Audited By SME?</Box>
                <FormControl fullWidth>
                  <Select
                    labelId="vra-label-2"
                    id="vra-select-2"
                    name="vra-select-2"
                    defaultValue=""
                    displayEmpty
                    disabled={!editAccess}
                    value={auditedBySME}
                    onChange={(e) => {
                      setAuditedBySME(e.target.value);
                    }}
                    inputProps={{ "aria-label": "Audited By SME" }}
                  >
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              
            </Grid>

          </Grid> */}


             
         <Grid container spacing={2} sx={{ pl: 2, pt: 3, pr: 2 }}>
  <Grid item xs={12} sm={2}>
    <Box sx={{ alignSelf: "center", textAlign: "center", height: "100%", display: "flex", alignItems: "center" }}>
      Accession Handled By
    </Box>
  </Grid>

  {/* All five items in one row */}
  <Grid item xs={12} sm={10}>
    <Grid container spacing={2}>
      <Grid item xs={12} sm={2.4}>
        <Box className="label">Primary / Secondary VRA</Box>
        <FormControl fullWidth>
          <Select
           labelId="vra-label-1"
                    id="vra-select-1"
                    name="vra-select-1"
                    defaultValue=""
                    displayEmpty
                    disabled={!editAccess}
                    value={handledBy}
                    onChange={(e) => {
                      setHandledBy(e.target.value);
            }}
             inputProps={{ "aria-label": "Primary or Secondary VRA" }}
          >
            <MenuItem value={"Primary VRA"}>Primary VRA</MenuItem>
                    <MenuItem value={"Substitute VRA"}>Substitute VRA</MenuItem>
          </Select>
        </FormControl>
      </Grid>

     
        <Grid item xs={12} sm={2.4} >
          <Box className="label">Audited By SME?</Box>
                <FormControl fullWidth>
                  <Select
                    labelId="vra-label-2"
                    id="vra-select-2"
                    name="vra-select-2"
                    defaultValue=""
                    displayEmpty
                    disabled={!editAccess}
                    value={auditedBySME}
                    onChange={(e) => {
                      setAuditedBySME(e.target.value);
                    }}
                    inputProps={{ "aria-label": "Audited By SME" }}
                  >
                    <MenuItem value={"Yes"}>Yes</MenuItem>
                    <MenuItem value={"No"}>No</MenuItem>
                  </Select>
                </FormControl>
        </Grid>

         <Grid item xs={12} sm={2.4} >
          <Box className="label">SME Audit Result</Box>
                <FormControl fullWidth>
                  <Select
                    labelId="vra-label-2"
                    id="vra-select-2"
                    name="vra-select-2"
                    defaultValue=""
                    displayEmpty
                    disabled={!editAccess}
                    value={SMEAuditResult}
                    onChange={(e) => {
                     setSMEAuditResult(e.target.value);
                    }}
                    inputProps={{ "aria-label": "Audited By SME" }}
                  >
                    <MenuItem value={"Pass"}>Pass</MenuItem>
                    <MenuItem value={"Fail"}>Fail</MenuItem>
                  </Select>
                </FormControl>
         </Grid>

          <Grid item xs={12} sm={2.4} >
            <Box className="label">
                        SME Comments&nbsp;
                        {/* <span style={{ color: "red" }}>*</span> */}
                      </Box>
                      <FormControl fullWidth>
                        <TextField
                          // sx={{ border: "1px solid #B2D4F8" }}
                          id="sme-comments"
                          name="sme-comments"
                          variant="outlined"
                          fullWidth
                          disabled={!editAccess}
                          value={SMEComments}
                           onChange={(e) => {
                     setSMEComments(e.target.value);
                    }}
                        />
                      </FormControl>
          </Grid>


           <Grid item xs={12} sm={2.4} ></Grid>
    
    </Grid>
  </Grid>
</Grid>

          {editAccess && <div
            className="update-btn"
            style={{ textAlign: "right", padding: "10px" }}
          >

            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmitClose}
              style={{ marginLeft: "10px" }}
            >
              Update & Close
            </Button>

            {serialNo !== count && (
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmitNext}
                style={{ marginLeft: "10px" }}
              >
                Update & Next
              </Button>
            )}
          </div>}
        </div>
      </Fragment>

      {Object.keys(parentData)?.length > 0 && (
        <Fragment>
          <div className="quality-view-header">Section Change Summary:</div>
          <Table
            sx={{ minWidth: 650 }}
            aria-label="simple table"
            className="custom-table"
          >
            <TableHead className="custom-table2-head">
              <TableRow>
                <TableCell>Any Change</TableCell>
                <TableCell>Exam Change</TableCell>
                <TableCell>Clinical Indication Change</TableCell>
                <TableCell>Comparison Change</TableCell>
                <TableCell>Technique Change</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="custom-table-body">
              <TableRow>
                <TableCell>
                  {parentData?.anyChange}
                </TableCell>
                <TableCell>{parentData?.examChange}</TableCell>
                <TableCell>{parentData?.clinicalIndicationChange}</TableCell>
                <TableCell>{parentData?.comparisonChange}</TableCell>
                <TableCell>{parentData?.techniqueChange}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Fragment>
      )}

      {data?.length > 0 && (
        <Fragment>
          <div className="quality-view-header">Section Summary:</div>
          <Table
            sx={{ minWidth: 650 }}
            aria-label="simple table"
            className="custom-table"
          >
            <TableHead className="custom-table2-head">
              <TableRow>
                <TableCell>Section</TableCell>
                <TableCell>Change Percentage</TableCell>
                <TableCell>Added Words</TableCell>
                <TableCell>Deleted Words</TableCell>
                <TableCell>Non-Impactful Changes</TableCell>
                <TableCell>Material Changes</TableCell>
                <TableCell>Exclusions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="custom-table-body">
              {data?.length > 0 &&
                data?.map((d, i) => (
                  <TableRow key={i}>
                    <TableCell>
                      <b>{d?.sectionName}</b>
                    </TableCell>
                    <TableCell>{d?.changePercentage}</TableCell>
                    <TableCell>{d?.addedWords}</TableCell>
                    <TableCell>{d?.deletedWords}</TableCell>
                    <TableCell>{d?.nonImpactful}</TableCell>
                    <TableCell>{d?.impactful}</TableCell>
                    <TableCell>{d?.exclusions}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Fragment>
      )}
    </div>
  );
};

export default QualityDetails;
